import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";

function tokenFromFragment(): string {
  return new URLSearchParams(window.location.hash.replace(/^#/, "")).get("token") || "";
}

export function EmailAuthPage() {
  const [token] = useState(tokenFromFragment);
  const [error, setError] = useState("");
  const started = useRef(false);
  const navigate = useNavigate();
  const { loading, setUser } = useAuth();

  useEffect(() => {
    window.history.replaceState(window.history.state, "", "/auth/email");
  }, []);

  useEffect(() => {
    if (loading || started.current) return;
    started.current = true;
    if (!token) {
      setError("This sign-in link is invalid or incomplete.");
      return;
    }
    void api.verifyEmailLogin(token).then((user) => {
      setUser(user);
      navigate("/account", { replace: true });
    }).catch((reason) => setError(reason instanceof Error ? reason.message : "This sign-in link could not be verified."));
  }, [loading, navigate, setUser, token]);

  return <section className="auth-gate">
    <p className="eyebrow">SECURE EMAIL SIGN-IN</p>
    <h1>{error ? "Link unavailable" : "Opening your listening room"}</h1>
    {error ? <><p className="form-error">{error}</p><Link className="button secondary" to="/account">Request a new link</Link></> : <p>Verifying your one-time link…</p>}
  </section>;
}
